import { render, staticRenderFns } from "./ObservationReportingForm.vue?vue&type=template&id=2aec2187&scoped=true"
import script from "./ObservationReportingForm.vue?vue&type=script&lang=js"
export * from "./ObservationReportingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aec2187",
  null
  
)

export default component.exports